import React, { useEffect, useRef } from "react";
export default function ElasticInput(props) {
  const minHeight = 41;
  const maxHeight = 150;
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.style.resize = "none";
      ref.current.style.height = "";
      const h = Math.max(
        Math.min(ref.current.scrollHeight + 4, maxHeight),
        minHeight
      );
      ref.current.style.height = `${h}px`;
    }
  });

  return <textarea {...props} ref={ref} />;
}
